import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-collections-due-today',
    templateUrl: './collections-due-today.component.html',
    styleUrls: ['./collections-due-today.component.scss'],
    standalone: false
})
export class CollectionsDueTodayComponent implements OnInit {
  collections = [
    { time: '09:30', customer: 'Acme Waste Ltd', type: 'Skip Collection' },
    { time: '11:00', customer: 'Greenfield Site', type: 'RO/RO' },
    { time: '13:15', customer: 'Harbour Logistics', type: 'Hook Loader' },
    { time: '15:45', customer: 'Midtown Depot', type: 'Skip Collection' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
